const productShortDescriptionSelector =
  ".hw-product-short-description__content";
const productShortDescriptionToggleSelector =
  ".hw-product-short-description__toggle";

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initProductShortDescription);
} else {
  initProductShortDescription();
}

function initProductShortDescription() {
  const description = document.querySelector(productShortDescriptionSelector);
  const toggle = document.querySelector(productShortDescriptionToggleSelector);

  if (!description || !toggle) return;

  toggle.addEventListener("click", () => {
    if (toggle.classList.contains("open")) {
      description.style.height = "45px";
      toggle.classList.remove("open");
      toggle.textContent = toggle.dataset.showMoreText || "Show More...";
      return;
    }
    const fullHeight = description.scrollHeight;
    description.style.height = fullHeight + "px";
    description.classList.add("open");
    toggle.classList.add("open");
    toggle.textContent = toggle.dataset.showLessText || "Show Less...";
  });
}
